<ul class="breadcrumbs">
  <li *ngFor="let breadcrumb of breadcrumbs; let last = last; index as i">
    <a [routerLink]="breadcrumb.url" class="breadcrumbs__label">{{ breadcrumb.label }}</a>
    <span class="breadcrumbs__pipe" *ngIf="!last"></span>
  </li>
</ul>
